import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { assign, each, remove } from 'lodash';
import { Card } from 'src/app/interfaces/card';
import { DataCard } from 'src/app/interfaces/data-card';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
  selector: 'app-card-column',
  templateUrl: './card-column.component.html',
  styleUrls: ['./card-column.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CardColumnComponent implements OnInit {
  constructor(protected SharedDataService: SharedDataService) {}

  @Input() cardCollection: (Card | DataCard<any>)[] = [];
  @Input() borderClassArray!: (
    | 'column-border'
    | 'column-border-left'
    | 'column-border-right'
    | 'column-border-top'
    | 'column-border-bottom'
  )[];

  // @Input() backgroundClassArray: ('background-color-grey' | 'background-color-white')[] = ['background-color-grey', 'background-color-white']

  // True/'single' enables single card selection
  // 'multiple' enables multi-card selection
  // false prevents selection
  @Input() enableSelection: boolean | ('single' | 'multiple') = false;

  @Output() cardClick = new EventEmitter<Card>();
  @Output() dataCardClick = new EventEmitter<DataCard<any>>();

  // If enableSelection is set to 'multiple', we add to the collection of cards.
  selectedCards: (Card | DataCard<any>)[] = [];

  processAllCardSelections(selectAll: boolean) {
    this.cardCollection.forEach((card) => {
      if (card.isSelected !== selectAll) {
        card.isClicked = selectAll;
      }
    });
  }

  isDataCard(card: Card | DataCard<any>): card is DataCard<any> {
    return (card as DataCard<any>).data;
  }

  cardClicked(card: Card | DataCard<any>) {
    if (this.enableSelection) {
      if (this.selectedCards.includes(card)) {
        remove(this.selectedCards, (c) => c === card);
      } else if (
        this.enableSelection !== 'multiple' &&
        this.selectedCards.length > 0
      ) {
        // If more than one card was selected, and selection type is not set to multiple, de-select all other cards.
        remove(this.selectedCards, (c) => {
          if (c !== card) {
            assign(c, { isSelected: false });
            return true;
          }
          return false;
        });

        this.selectedCards[0] = card;
      } else {
        this.selectedCards.push(card);
      }
    }

    if (this.isDataCard(card)) {
      this.dataCardClick.emit(card);
    } else {
      this.cardClick.emit(card);
    }
  }

  ngOnInit(): void {
    if (this.enableSelection) {
      each(this.cardCollection, (c) => {
        if (c.isSelected) {
          this.selectedCards.push(c);
        }
      });
    }

    this.SharedDataService.listenForEvent().subscribe({
      next: ({ eventName, data }) => {
        if (
          eventName === 'processAllCardSelection' &&
          typeof data === 'boolean'
        ) {
          this.processAllCardSelections(data);
        }
      }
    });
  }
}
